<template>
  <div class="profile-general">
    <div class="tab-profile-content">
      <div class="profile-rating">
        <div v-if="userLogged">
          <div class="profile-menu">
            <div class="tab-profile-top">
              <div class="profile-avatar">
                <aha-avatar
                  :name="`${currentUser.firstName} ${currentUser.lastName}`"
                  :image="currentUser.avatar"
                  :id="currentUser.id"
                  :width="40"
                  :height="40"
                  class="mr-2 text-lg"
                />
              </div>
              <div class="profile-info">
                <div class="profile-info-name">
                  {{ userFullName }}
                </div>
                <div class="profile-info-email">
                  {{ currentUser.email }}
                </div>
              </div>
              <div
                class="profile-toggle"
                @click="toggleDropdown"
              >
                <i v-show="isShowDropdown" class="fas fa-chevron-up" />
                <i v-show="!isShowDropdown" class="fas fa-chevron-down" />
              </div>
            </div>
            <div
              class="navbar"
              :class="{
                'show': isShowDropdown
              }"
            >
              <div class="nav-item" @click="handleLogoutButtonClick">
                <aha-svg
                  name="profile_logout"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  :maintainColor="true"
                />
                <span class="text">{{ $t('log_out') }}</span>
              </div>
            </div>
            <div class="divider" />
            <div class="nav-item" @click="loginToPresenter">
              <img
                src="@/assets/images/icon-aha.svg"
                width="20"
                alt=""
              >
              <span class="text">{{ $t('present_with_ahaslides') }}</span>
              <aha-icon
                class="icon-right"
                name="open-new-window"
              />
            </div>
          </div>
        </div>
        <div v-else class="profile-sign-in">
          <div class="profile-logo">
            <img
              :src="require('@/assets/images/logo-ahaslides.svg')"
              alt="ahaslides"
              width="154"
              height="26"
            >
          </div>
          <p class="text-center help-text">
            {{ $t('sign_in_to_save_presentation') }}
          </p>
          <GoogleButtonProfile type="login">
            {{ $t('continue_with_google') }}
          </GoogleButtonProfile>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleButtonProfile from '@/components/common/GoogleButtonProfile.vue'
import { mapState } from 'vuex'
import Config from '@/config'
import util from '@/util'
import cookie from '@/services/cookie'

export default {
  components: {
    GoogleButtonProfile,
  },
  data() {
    return {
      isShowDropdown: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    userLogged() {
      return this.currentUser && this.currentUser.id
    },
    userFullName() {
      return this.currentUser && `${this.currentUser.firstName} ${this.currentUser.lastName}`.trim()
    },
  },
  methods: {
    loginToPresenter() {
      const ahaAudienceToken = cookie.getValue('ahaAudienceToken')

      if (ahaAudienceToken) {
        window.open(`${Config.presenterUrl}/pages/cross-app-login?token=${ahaAudienceToken}&from=audience`, '_blank')
      } else {
        window.open(`${Config.presenterUrl}/pages/register?from=audience`, '_blank')
      }

      util.ga4Track('Account > Present with AhaSlides')
    },
    toggleDropdown() {
      this.isShowDropdown = !this.isShowDropdown

      const eventName = this.isShowDropdown
        ? 'Account > Collapse'
        : 'Account > Expand'

      util.ga4Track(eventName)
    },
    async handleLogoutButtonClick() {
      util.setCookieToken('')
      util.removeTokenCookie('ahaAudienceToken')

      if (this.presentation) {
        localStorage.removeItem(`aha-presentation-${this.presentation.id}`)
      }

      util.ga4Track('Account > Logout')

      window.location.reload()
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.profile-rating {
  margin: 0 auto;
  padding: 16px;
  max-width: 600px;
}

.tab-profile-top {
  $w-toggle: 26px;
  $w-avatar: 40px;

  display: flex;
  margin-bottom: 16px;

  .profile-avatar {
    width: $w-avatar;
    flex-shrink: 0;
  }

  .profile-info {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    font-size: 0.875rem;
    line-height: 1.125rem;
    width: calc(100% - $w-avatar - $w-toggle);

    .profile-info-name,
    .profile-info-email {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .profile-info-name {
      font-weight: 700;
    }

    .profile-info-email {
      font-size: 0.9rem;
      line-height: 1rem;
    }
  }

  .profile-toggle {
    width: $w-toggle;
    text-align: right;
    margin-left: auto;
    align-self: center;
    color: $base-70;
    font-size: 1.25rem;
    cursor: pointer;
  }
}

.profile-logout {
  cursor: pointer;
  line-height: 3.5rem;
  white-space: nowrap;
  --tw-text-opacity: 1;
  color: rgba(75, 75, 75, var(--tw-text-opacity));

  svg.path-fill-current.inline-block {
    margin-right: 0.5rem;
    display: inline-block;
    vertical-align: middle;
    color: rgb(153, 153, 153);
  }
}

.profile-sign-in {
  .help-text {
    font-size: 1.25rem;
    line-height: 1.75;
    font-weight: 700;
    color: #282E3E;
    margin-bottom: 24px;
  }

  input[type='text'] {
    height: 40px;
    border: none;
    background-color: #fff;
    padding-right: 8px;
    min-width: 50px;
    border-radius: 4px;
    border: 1px solid #ddd;
  }

  .button-submit {
    width: 90px;
    font-size: 14px;
    text-transform: capitalize;
    padding: 0;
    text-align: center;
    height: 40px;
    line-height: 40px;
    font-weight: bold;
    border-radius: 20px;
    background-color: $brand-a100;

    i {
      font-size: 14px;
    }

    .loading-spinner {
      margin-left: 4.5px;
      width: 1.2em;
      height: 1.2em;
    }
  }
}

.profile-logo {
  text-align: center;
  margin-top: 32px;
  margin-bottom: 24px;
}

.text-center {
  text-align: center;
}

.profile-menu {
  background-color: #fff;
  margin-top: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0px 1px 3px 0px #D3D7E1CF;
}

.divider {
  height: 1px;
  background-color: $base-50;
  margin-top: 16px;
  margin-bottom: 16px;
}

.navbar {
  display: none;

  &.show {
    display: block;
  }
}

.nav-item {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 8px;

  .icon-left,
  .icon-right,
  .text {
    flex-shrink: 0;
  }

  .text {
    padding: 0 8px;
    color: #313131;
    font-size: 0.875rem;
    flex-grow: 1;
    align-self: center;
  }

  .icon-left {
    color: $base-70;
  }

  .icon-right {
    margin-left: auto;
    color: $base-70;
  }
}
</style>
